$(document).ready(function () {
    console.log('View mode script loaded');

    const MOBILE_MEDIA_QUERY = '(max-width: 749px)';

    function isMobileViewport() {
        return window.matchMedia(MOBILE_MEDIA_QUERY).matches;
    }

    function getViewStorageKey() {
        return isMobileViewport() ? 'view_mobile' : 'view_desktop';
    }

    function getDefaultView() {
        return isMobileViewport() ? 'grid' : 'list';
    }

    function getSavedView() {
        if (isMobileViewport()) {
            return localStorage.getItem('view_mobile') || getDefaultView();
        }
        return localStorage.getItem('view_desktop') || localStorage.getItem('view_mode') || getDefaultView();
    }

    // Function to apply the saved view mode
    function applySavedView() {
        console.log('Applying saved view...');
        const savedView = getSavedView();
        const $collectionElement = $('ul#product-grid, .product-grid, #search-grid');

        console.log('Collection element found:', $collectionElement.length > 0);
        if (!$collectionElement.length) return; // Exit if collection element doesn't exist

        // Remove existing view classes and apply the saved view
        if (savedView === 'list') {
            console.log('Setting list view');
            $collectionElement
                .removeClass("grid product-grid grid--2-col-tablet-down grid--4-col-desktop")
                .addClass("list product-list");
        } else {
            console.log('Setting grid view');
            $collectionElement
                .removeClass("list product-list")
                .addClass("grid product-grid grid--2-col-tablet-down grid--4-col-desktop");
        }

        // Update data attribute for consistent state
        document.documentElement.setAttribute('data-view-mode', savedView);

        // Update button states - using more flexible selectors
        console.log('Updating button states');
        $('[id^="gridview"], [id^="listview"]').removeClass('active inactive')
            .filter(savedView === 'list' ? '[id^="listview"]' : '[id^="gridview"]')
            .addClass('active')
            .siblings('[id^="gridview"], [id^="listview"]')
            .addClass('inactive');
    }

    // Function to handle view toggle
    function handleViewToggle(e) {
        e.preventDefault();
        console.log('View toggle clicked:', this.id);

        // More flexible ID checking
        const isGridView = this.id.toLowerCase().includes('grid');
        const view = isGridView ? 'grid' : 'list';

        console.log('Setting view to:', view);

        // Only update if not already active
        if ($(this).hasClass('inactive')) {
            localStorage.setItem(getViewStorageKey(), view);
            applySavedView();
        } else {
            console.log('View already active, no change needed');
        }
    }

    // Function to initialize view mode
    function initViewMode() {
        console.log('Initializing view mode...');

        // More flexible event delegation
        $(document).off('click', '[id^="gridview"], [id^="listview"]');

        // Set up new event handlers with more flexible selectors
        $(document).on('click', '[id^="gridview"], [id^="listview"]', handleViewToggle);

        console.log('View mode buttons found:', $('[id^="gridview"], [id^="listview"]').length);

        // Initial application of saved view
        applySavedView();
    }

    // Function to check for URL changes
    let lastUrl = location.href;
    new MutationObserver(() => {
        const url = location.href;
        if (url !== lastUrl) {
            lastUrl = url;
            setTimeout(initViewMode, 300); // Small delay to allow DOM to update
        }
    }).observe(document, {subtree: true, childList: true});

    // Listen for Shopify section updates
    document.addEventListener('shopify:section:load', function() {
        setTimeout(initViewMode, 300);
    });

    // Listen for AJAX complete events (for filtering/sorting)
    $(document).ajaxComplete(function() {
        setTimeout(initViewMode, 300);
    });

    // Initial setup
    initViewMode();

    // Re-apply when crossing the mobile/desktop breakpoint
    window.matchMedia(MOBILE_MEDIA_QUERY).addEventListener('change', applySavedView);
});
